import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  booleanAttribute,
  SimpleChanges,
  inject,
} from '@angular/core';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { TableComponent } from '@app/shared/components/table/table.component';
import { Pagination } from '../../../../../../shared/model/pagination.model';
import { ApiService } from '@core/providers/http';
import { BolsaService, BolseiroService } from '../../../api/services';
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Select } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import extenso from 'extenso'; // Importe a biblioteca
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { Subject, takeUntil } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { InstituicaoEnsinoService } from '../../../api/services/instituicao-ensino.service';

interface VerificarRegraPagamentoPayload {
  id: string;
  pedidoID: number;
  bolseiroID: number;
  requerenteID: number;
  isActive: boolean;
  tipoBolsa: number;
  paisID: number;
  instituicaoGestoraID: number;
  nivelAcademico: number;
  areaProgramaFormacaoID: number;
  programaFormacaoID: number;
  anoCurricularFrequencia: string;
  valorSubsidio: number;
}

@Component({
  selector: 'app-ficha-de-cadastro',
  imports: [
    SearchBarComponent,
    TableComponent,
    CommonModule,
    ReactiveFormsModule,
    Select,
    InputTextModule,
    NgxMaskPipe,
    NgxMaskDirective,
    DataVoidComponent,
  ],
  providers: [ApiService, BolseiroService, BolsaService, provideNgxMask(), ConfirmationService, MessageService, InstituicaoEnsinoService],
  templateUrl: './ficha-de-cadastro.component.html',
  styleUrl: './ficha-de-cadastro.component.scss',
})
export class FichaDeCadastroComponent implements OnInit {
  pagination: Pagination<any> = new Pagination<any>();
  @Output() formValueChanges = new EventEmitter<any>();
  @Input() bolseiroID!: string;
  @Input() documento!: any;
  @Input({ transform: booleanAttribute }) disabled = false;
  bolsaService = inject(BolsaService);
  bolseiroService = inject(BolseiroService);
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  confirm = inject(ConfirmationService);
  messageService = inject(MessageService)
  estudantes: any[] = [];
  InstEnsino: any[] = [];
  form!: FormGroup;
  fb = inject(FormBuilder);
  private previousInstituicaoId: string | null = null;
  private destroy$ = new Subject<void>();
  bolsa: any;
  valorRegra: string | null = null;

  constructor() {
    this.form = this.fb.group({
      instituicao: ['', Validators.required],
      estudanteID: ['', Validators.required],
      bolsaID: ['', [Validators.required]],
      idioma: ['pt', [Validators.required]],
      valores: [{ value: '', disabled: true }, [Validators.required]],
      valoresextenso: [{ value: '', disabled: true }, [Validators.required]],
      moeda: [''],
    });

    this.form.get('valores')?.disable({ emitEvent: false });
    this.form.get('valoresextenso')?.disable({ emitEvent: false });

    this.form.controls['bolsaID'].valueChanges.subscribe((value) => {
      const formattedValue = {
        bolsaID: value,
      };
      this.formValueChanges.emit({
        data: formattedValue,
        valid: this.form.valid,
      });
    });

    this.form.controls['estudanteID'].valueChanges.subscribe((value) => {
      this.pagination = new Pagination<any>().deserialize([]);
      if (!value) return;
      this.loadAllBolsa({
        BolseiroID: value,
      });
    });

    // Valor → gera extenso (parse PT → número)
    this.form.get('valores')!
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((valor) => {
        const num = this.parsePtNumber(valor);
        if (num !== null) {
          this.form.get('valoresextenso')?.setValue(extenso(num, { mode: 'number' }), { emitEvent: true });
        } else {
          this.form.get('valoresextenso')?.setValue('', { emitEvent: true });
        }
      });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadAllBolsa({
      BolseiroID: this.form.controls['estudanteID'].value,
    });
  }

  onRadioChange(event: any) {
    this.form.controls['bolsaID'].setValue(event.id);
  }

  getSeverity(status: string) {
    switch (status) {
      case 'Activo':
        return 'success';
      case 'Inactivo':
        return 'warn';
      case 'Suspenso':
        return 'danger';
      case 'Finalizado':
        return 'success';
      case 'Pendente':
        return 'info';
      default:
        return 'warn';
    }
  }

  getAllBolseiros(p0: { InstituicaoEnsinoID: string; }) {
    this.bolseiroService
      .list({ pageSize: 100, OrderBy: 'id desc', ...p0 })
      .subscribe((bolseiros) => {
        this.estudantes = bolseiros.data;
      });
  }

  ngOnInit(): void {
    // Chama getAllBolseiros com o valor inicial do campo instituicao, se houver
    const instituicaoId = this.form.get('instituicao')?.value;
    if (instituicaoId) {
      this.getAllBolseiros({ InstituicaoEnsinoID: instituicaoId });
    }
    this.syncDisabled(); // <= NOVO

    this.getAllInstituicoesEnsino();

    this.previousInstituicaoId = this.form.get('instituicao')?.value ?? null;

    this.form
      .get('instituicao')!
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((novoId) => this.handleInstituicaoChange(novoId));
  }

  private handleInstituicaoChange(novoId: string) {
    const anterior = this.previousInstituicaoId;

    this.estudantes = [];
    if (novoId) this.getAllBolseiros({ InstituicaoEnsinoID: novoId });

    this.confirm.confirm({
      header: 'Confirmar alteração',
      message:
        'Tem a certeza que pretende mudar de instituição? Os estudantes seleccionados serão desmarcados.',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, mudar',
      rejectLabel: 'Cancelar',
      accept: () => {
        this.clearStudents();
        this.previousInstituicaoId = novoId ?? null;
      },
      reject: () => {
        this.form.get('instituicao')!.setValue(anterior, { emitEvent: false });
      },
    });
  }

  private buildRegraPayload(bolsa: any): VerificarRegraPagamentoPayload {
    const matricula = this.pickMatricula(bolsa);
    const anoCurricular = matricula?.anoCurricular ?? bolsa?.anoCurricular ?? 1;

    const programaFormacaoID =
      bolsa?.programaFormacaoID ??
      bolsa?.areaProgramaFormacao?.programaFormacaoId ??
      bolsa?.areaProgramaFormacao?.programaFormacaoID ??
      0;

    const bolseiroID = Number(bolsa?.bolseiroID ?? bolsa?.bolseiro?.id ?? 0);

    return {
      id: '0',
      pedidoID: Number(bolsa?.pedidoID ?? 0),
      bolseiroID,
      requerenteID: Number(bolsa?.requerenteID ?? 0),
      isActive: Boolean(bolsa?.isActive ?? true),
      tipoBolsa: Number(bolsa?.tipoBolsa ?? 0),
      paisID: Number(bolsa?.paisID ?? 0),
      instituicaoGestoraID: Number(bolsa?.instituicaoGestoraID ?? bolsa?.instituicaoGestora?.id ?? 0),
      nivelAcademico: Number(bolsa?.nivelAcademico ?? 0),
      areaProgramaFormacaoID: Number(bolsa?.areaProgramaFormacaoID ?? bolsa?.areaProgramaFormacao?.id ?? 0),
      programaFormacaoID: Number(programaFormacaoID),
      anoCurricularFrequencia: String(anoCurricular),
      valorSubsidio: Number(bolsa?.valorSubsidio ?? 0),
    };
  }

  private fetchValorByRegra(bolsa: any): void {
    if (!bolsa) {
      this.valorRegra = null;
      this.emitPayload();
      return;
    }

    const body = this.buildRegraPayload(bolsa);
    this.bolsaService
      .verificarRegraPagamento(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          let valor = Number(res?.valorPagamento ?? 0);
          let moeda = this.form.get('moeda')?.value ?? '';

          if (!valor || Number.isNaN(valor)) {
            const lista = Array.isArray(res?.regraPagamentoSubsidio) ? res.regraPagamentoSubsidio : [];
            const apoioFormacao =
              lista.find((x: any) => x?.subsidioId === 2) ??
              lista.find((x: any) =>
                String(x?.subsidios?.descricao ?? '').toLowerCase().includes('apoio a formação')
              );
            valor = Number(apoioFormacao?.valor ?? 0);
            moeda = apoioFormacao?.moeda ?? '';
          }

          // guarda formatações
          this.valorRegra = valor > 0 ? this.formatPtBR(valor) : null;

          // preenche inputs “valores”, “moeda”, “valoresextenso”
          const ext = valor > 0 ? extenso(valor, { mode: 'number' }) : '';
          this.form.patchValue(
            {
              valores: this.valorRegra ?? '',
              valoresextenso: ext,
              moeda,
            },
            { emitEvent: true }
          );
        },
        error: () => {
          this.valorRegra = null;
          this.form.patchValue({ valores: '0,00', valoresextenso: 'zero', moeda: '-' }, { emitEvent: true });
        },
      });
  }

  private clearStudents() {
    this.estudantes = [];
    this.form.get('estudanteID')!.setValue(null);
    this.pagination = new Pagination<any>().deserialize([]);
    this.bolsa = null;
    this.messageService.add({
      severity: 'info',
      summary: 'Limpo',
      detail: 'Estudantes desmarcados ao mudar de instituição.',
    });
  }

  getAllInstituicoesEnsino() {
    this.instituicaoEnsinoService
      .list({ pageSize: 1000, OrderBy: 'ID desc' })
      .pipe(takeUntil(this.destroy$))
      .subscribe((institutions) => {
        this.InstEnsino = institutions.data;
      });
  }

  loadAllBolsa(queryParams: any = {}) {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 5,
    };
    this.bolsaService
      .list({
        ...params,
        BolseiroID: queryParams.BolseiroID || this.bolseiroID,
      })
      .subscribe(
        (response) => {
          this.bolsa = response?.data?.[0];
          this.form.controls['bolsaID'].setValue(this.bolsa?.id);
          this.pagination = new Pagination<any>().deserialize(response);
          this.fetchValorByRegra(this.bolsa);
        },
        (error) => {
          console.error('Erro ao carregar bolsa:', error);
        }
      );
  }

  ngOnChanges(_: SimpleChanges): void {
    this.syncDisabled(); // <= NOVO
  }

  private syncDisabled() {
    if (this.disabled) {
      this.form.disable({ emitEvent: false });
    } else {
      this.form.enable({ emitEvent: false });
      this.form.get('valores')?.disable({ emitEvent: false });
      this.form.get('valoresextenso')?.disable({ emitEvent: false });
    }
  }

  private parsePtNumber(value: unknown): number | null {
    if (value === null || value === undefined) return null;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;

    // mantém dígitos, vírgula, ponto e sinal
    let s = String(value).replace(/[^\d.,-]/g, '');
    // remove separador de milhar (.) quando seguido de 3 dígitos
    s = s.replace(/\.(?=\d{3}(\D|$))/g, '');
    // vírgula decimal → ponto
    s = s.replace(',', '.');

    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  }


  private emitPayload(): void {
    const data = {
      bolsaID: this.form.get('bolsaID')?.value,
      valores: String(this.form.get('valores')?.value ?? ''),
      valoresextenso: this.form.get('valoresextenso')?.value,
      moeda: this.form.get('moeda')?.value,
      idioma: this.form.get('idioma')?.value,
      tipoDocumento: 3,
      paisBolsa: this.form.get('paisBolsa')?.value,
      estudanteID: this.form.get('estudanteID')?.value,
    };
    this.formValueChanges.emit({ data, valid: this.form.valid });
  }

  private formatPtBR(n: number): string {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n || 0);
  }

  private pickMatricula(b: any) {
    const arr = Array.isArray(b?.matricula) ? b.matricula : [];
    if (!arr.length) return null;

    const emCurso = arr.find((m: any) => (m?.estadoDescricao || '').toLowerCase() === 'em curso');
    if (emCurso) return emCurso;

    const parse = (d: any) => (d ? new Date(d).getTime() : 0);
    return arr.slice().sort((a: any, c: any) => parse(c?.dataInicio) - parse(a?.dataInicio))[0] || null;
  }
}
